<template>
  <BaseForm
    fullHeight
    @submit="submit"
  >
    <div :class="[$style.base, { [$style.smallScreen]: $screen === 's' }]">
      <div :class="$style.main">
        <div :class="$style.top">
          <div :class="$style.mainInner">
            <InvoicePreview editable />
          </div>
        </div>
        <div :class="$style.bottom">
          <div :class="$style.amountDue">
            <BaseHeading size="s">{{ $t('register.amount_due') }}</BaseHeading>
            <BaseHeading
              size="xl"
              v-test="'register-transactions-due'"
            >
              {{ filters.currency(outstandingAmount > 0 ? outstandingAmount : 0) }}
            </BaseHeading>
          </div>
        </div>
      </div>
      <Footer />
    </div>

    <OpenDrawerModal
      v-if="showOpenDrawerModal"
      @close="showOpenDrawerModal = false"
      @success="sendPayload"
    />
    <CheckoutModal
      v-if="showCheckoutOverviewModal && savedOrderId"
      :orderId="savedOrderId"
      :invoiceJustIssued="invoiceJustIssued"
    />
    <CannotSaveOutstandingModal
      v-if="showCannotSaveOutstandingModal && order?.id"
      :orderId="order.id"
      @close="showCannotSaveOutstandingModal = false"
    />
  </BaseForm>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import filters from '@/filters';
import CheckoutModal from '@/modules/register/builder/checkout-modal/index.vue';
import CannotSaveOutstandingModal from '@/modules/register/modals/CannotSaveOutstanding.vue';
import OpenDrawerModal from '@/modules/register/modals/open-drawer/index.vue';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import { useRegisterStore } from '@/modules/register/stores/register';
import { usePaymentSubmit } from '../submit';
import Footer from './Footer.vue';
import InvoicePreview from './invoice-preview/index.vue';

const { order, outstandingAmount } = storeToRefs(useRegisterOrderStore());
const { showOpenDrawerModal, showCannotSaveOutstandingModal } = storeToRefs(
  useRegisterStore(),
);
const {
  submit,
  showCheckoutOverviewModal,
  sendPayload,
  savedOrderId,
  invoiceJustIssued,
} = usePaymentSubmit();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:not(.smallScreen) {
    height: 100%;
  }
}

.main {
  padding: $spacing;

  .base:not(.smallScreen) & {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: scroll;
  }

  .base.smallScreen & {
    padding-bottom: $input-height + $spacing * 2;
  }
}

.amountDue {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.top {
  flex-shrink: 0;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: $spacing;
  padding-top: $spacing * 2;
  margin-top: auto; // Needed for correct positioning to the bottom of the flex container

  .base.smallScreen & {
    padding-bottom: $spacing;
  }
}

.mainInner {
  overflow-y: auto;
  flex-grow: 1;
}
</style>
